import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import styles from './SideNav.module.scss'

// Desktop/tablet: vertical, independently scrollable list of questions with their status
function SideNav({ questions, results, index, onSelect }) {
  const activeRef = useRef(null)

  useEffect(() => {
    if (activeRef.current) activeRef.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
  }, [index])

  return (
    <nav className={styles.SideNav} aria-label={i18n('qv_questions')}>
      <div className={styles.title}>{i18n('qv_questions')}</div>
      <div className={styles.list}>
        {questions.map((question, i) => {
          const result = results[question.id]
          return (
            <button
              key={question.id}
              ref={i === index ? activeRef : null}
              type="button"
              aria-current={i === index ? 'step' : undefined}
              className={classNames(styles.item, {
                [styles.active]: i === index,
                [styles.ok]: result === true,
                [styles.bad]: result === false,
              })}
              onClick={() => onSelect(i)}
            >
              <span className={styles.number}>{i + 1}</span>
              <span className={styles.label}>{i18n('qv_question')} {i + 1}</span>
              {result === true && <AiOutlineCheck className={styles.status} size={16} />}
              {result === false && <AiOutlineClose className={styles.status} size={16} />}
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default SideNav
